import axios from '../../core/http';

import { config } from '../../config';
import { getLocalStorageItem } from '../../commons/utils/localStorage';

const baseAgentApiUrl = `${config.baseInpulseAgentApiUrl}`;

const getStandardHeaders = async () => {
  const accessToken = await getLocalStorageItem('loopbackAccessToken');

  return {
    'Content-Type': 'application/json',
    Authorization: accessToken,
  };
};

/**
 * This file aims to centralize all axios-related logic, reducing the amount of code
 * necessary to perform an API call.
 *
 * @param {string} url - The relative or absolute URL to request data from.
 * @param {Object} params - Optional query parameters to be sent with the request.
 * @param {string} responseType - The type of data to return. Default: 'json'
 * @return {Promise<any>} A Promise that resolves with the response data from the server.
 *
 */
const apiGet =
  (baseAgentApiUrl) =>
  async (url, params, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.get(`${baseAgentApiUrl}${url}`, {
      params,
      headers,
      ...config,
    });

    return data;
  };

const apiPost =
  (baseAgentApiUrl) =>
  async (url, bodyParams, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.post(
      `${baseAgentApiUrl}${url}`,
      { ...bodyParams },
      { headers, ...config },
    );

    return data;
  };

const apiPut =
  (baseAgentApiUrl) =>
  async (url, bodyParams, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.put(
      `${baseAgentApiUrl}${url}`,
      { ...bodyParams },
      { headers, ...config },
    );

    return data;
  };

const apiPatch =
  (baseAgentApiUrl) =>
  async (url, bodyParams, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.patch(
      `${baseAgentApiUrl}${url}`,
      { ...bodyParams },
      { headers, ...config },
    );

    return data;
  };

const apiDelete =
  (baseAgentApiUrl) =>
  async (url, payload, config = { responseType: 'json' }) => {
    const headers = await getStandardHeaders();

    const { data } = await axios.delete(`${baseAgentApiUrl}${url}`, {
      headers,
      data: payload,
      ...config,
    });

    return data;
  };

export const AgentAPIcaller = {
  apiGet: apiGet(baseAgentApiUrl),
  apiPost: apiPost(baseAgentApiUrl),
  apiPut: apiPut(baseAgentApiUrl),
  apiPatch: apiPatch(baseAgentApiUrl),
  apiDelete: apiDelete(baseAgentApiUrl),
};
